// Enum for Templates types
export const TEMPLATES_TYPE = {
  ALL: "all",
  FEATURED: "featured_tab",
  SHARED: "shared_templates_tab",
  MY_TEMPLATES: "my_templates_tab",
};
